import type { RouteRecordRaw } from 'vue-router'

export const quoteRoutes: RouteRecordRaw[] = [
	{
		path: '/ponuky',
		name: 'quotes',
		component: () => import('./QuotesListPage.vue'),
		meta: { titleSk: 'Ponuky', requiresAuth: true },
	},
	{
		path: '/ponuky/:id',
		name: 'quote-detail',
		component: () => import('./QuoteDetailPage.vue'),
		meta: { titleSk: 'Detail ponuky', breadcrumbSk: ['Ponuky'], requiresAuth: true },
	},
]
